import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const Breadcrumb = (props) => {
    const location = useLocation()
    const path = location.pathname.split('/').slice(1);

    let mypath
    if (path[0] === 'categories') {
        mypath = MyLogicPath(path.slice(1), 'categories')
    } else if (path[0] === 'products') {
        // path must be array => (4) ['categories', 'bearing', 'ball-bearing', 'iner-bearing']
        var productPath = props.productCat;
        productPath = productPath.concat(path.slice(1))
        mypath = MyLogicPath(productPath, 'categories')
    }else {
        mypath = MyLogicPath(path)
    }

    const styleWhite = ['categories', 'categories', 'support-center', 'search', 'brands'];

    return (
        // <ol className={`${path[0] === 'categories' || path[0] === 'search' ? 'd-flex my-breadcrumb': 'd-flex my-breadcrumb-2'}`}>
        <ol className={`${ styleWhite.includes(path[0]) ? 'd-flex my-breadcrumb': 'd-flex my-breadcrumb-2'}`}>
            <li><Link to="/">Home</Link></li>
            {
                mypath.map((val, i, array) => (
                    <li key={i}>
                        {i + 1 !== array.length ?
                            <Link to={'/' + val.slug}>{val.name}</Link>
                            :
                            <span>{val.name}</span> 
                        }
                    </li>
                ))
            }
        </ol>
    )
}

export default Breadcrumb


const MyLogicPath = (path, additional = null) => {
    const BreadcrumbLink = [];
    
    path.map((v, i, array) => {
        var link = {}
        if (i === 0) {
            link = {
                slug: v,
                name: v.replaceAll("-", " ")
           } 
        }else if (i === 1) {
            link = {
                slug: [array[0]] + '/' + v,
                name: v.replaceAll("-", " ")
           } 
        }else if (i === 2) {
            link = {
                slug: [array[0]] + '/' + [array[1]] + '/' + v,
                name: v.replaceAll("-", " ")
           } 
        }else if (i === 3) {
            link = {
                slug: [array[0]] + '/' + [array[1]] + '/' + [array[2]] + '/' + v,
                name: v.replaceAll("-", " ")
           } 
        }else if (i === 4) {
            link = {
                slug: [array[0]] + '/' + [array[1]] + '/' + [array[2]] + '/' + [array[3]] + '/' + v,
                name: v.replaceAll("-", " ")
            }    
        }else if (i === 5) {
            link = {
                slug: [array[0]] + '/' + [array[1]] + '/' + [array[2]] + '/' + [array[3]] + '/' + [array[4]] + '/' + v,
                name: v.replaceAll("-", " ")
            }    
        } else {
            link = {};
        }
        
        link.slug = additional ? additional + '/' + link.slug : link.slug; 

        BreadcrumbLink.push(link)
    })

    return BreadcrumbLink;
}
